import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const orderEditValidationGroup = 'orderEditValidationGroup';

export const OrderEditFormBackButtonId = 'OrderEditForm.backButton';
const OrderEditFormBackButtonOptions: iButtonDisplayOptions = {
    id: OrderEditFormBackButtonId,
    validationGroup: orderEditValidationGroup,
    //
    width: '200px',
    type: 'danger',
    stylingMode: 'outlined',
};
propsStore.insert(OrderEditFormBackButtonOptions);

export const OrderEditFormDeleteButtonId = 'OrderEditForm.deleteButton';
const OrderEditFormDeleteButtonOptions: iButtonDisplayOptions = {
    id: OrderEditFormDeleteButtonId,
    //
    width: '200px',
    text: 't~OrderEditForm:deleteButton',
    type: 'danger',
    stylingMode: 'text',
};
propsStore.insert(OrderEditFormDeleteButtonOptions);

export const OrderEditFormBackToListButtonId = 'OrderEditForm.backToListButton';
const OrderEditFormBackToListButtonOptions: iButtonDisplayOptions = {
    id: OrderEditFormBackToListButtonId,
    //
    width: '200px',
    text: 't~OrderEditForm:backToListButton',
    type: 'success',
    stylingMode: 'outlined',
};
propsStore.insert(OrderEditFormBackToListButtonOptions);

export const OrderEditFormNextButtonId = 'OrderEditForm.nextButton';
const OrderEditFormNextButtonOptions: iButtonDisplayOptions = {
    id: OrderEditFormNextButtonId,
    validationGroup: orderEditValidationGroup,
    //
    width: '200px',
    type: 'success',
    stylingMode: 'contained',
};
propsStore.insert(OrderEditFormNextButtonOptions);
